/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QuoteRestrictionType = {
    PickupOpenBefore: 'PickupOpenBefore',
    DeliveryCloseAfter: 'DeliveryCloseAfter',
    MinTransitWindowHours: 'MinTransitWindowHours'
} as const;
export type QuoteRestrictionType = typeof QuoteRestrictionType[keyof typeof QuoteRestrictionType];


export function instanceOfQuoteRestrictionType(value: any): boolean {
    for (const key in QuoteRestrictionType) {
        if (Object.prototype.hasOwnProperty.call(QuoteRestrictionType, key)) {
            if (QuoteRestrictionType[key as keyof typeof QuoteRestrictionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function QuoteRestrictionTypeFromJSON(json: any): QuoteRestrictionType {
    return QuoteRestrictionTypeFromJSONTyped(json, false);
}

export function QuoteRestrictionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteRestrictionType {
    return json as QuoteRestrictionType;
}

export function QuoteRestrictionTypeToJSON(value?: QuoteRestrictionType | null): any {
    return value as any;
}

export function QuoteRestrictionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): QuoteRestrictionType {
    return value as QuoteRestrictionType;
}

